import { displayError } from "../../utils/messageToast";
import { SetupRC } from "../../apis/apisRCByAuthorization";

export const getSkillId = async (
  skillIdForm: string,
  authorization: string,
  ambient: string,
  setSkillName: React.Dispatch<React.SetStateAction<string>>,
  signOut: () => void
) => {
  try {
    if (skillIdForm === "") {
      return;
    }
    const apiClient = SetupRC(authorization);
    const response = await apiClient.get(
      `/get-skill?skillId=${skillIdForm}&ambient=${ambient}`
    );
    setSkillName(response.data.name);
    return response.data;
  } catch (error: any) {
    // displayError("Habilidade não encontrada!");
    return;
  }
};
